import { RoutingPath } from 'mbs-ui-shared@constants';

export const excludedSleekPlanUrls = [RoutingPath.ApNewBackupHistory];

export const excludedFooterUrls = [RoutingPath.ApNewBackupHistory];
